<template>
  <div class="move-dialog" :style="{ width: dialogWidth, height: dialogHeight}" v-if="showDialog" ref="moveDialog">
    <div class="move-dialog-header" @mousedown="handleDragStart($event)">
      <label>{{ dialogTitle }}</label>
      <el-tooltip class="item" effect="dark" content="关闭" placement="top-start">
        <i class="el-icon-close close-btn" @click="handleClose"></i>
      </el-tooltip>
    </div>
    <div class="move-dialog-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoveDialog",
  props: {
    // 是否显示
    showDialog: {
      type: Boolean,
      default: false,
    },
    // 弹框标题
    dialogTitle: {
      type: String,
      default: "移动弹框",
    },
    // 弹框宽度
    dialogWidth: {
      type: String,
      default: "650px",
    },
    // 弹框高度
    dialogHeight: {
      type: String,
      default: "500px",
    },
  },
  methods: {
    //拖拽
    handleDragStart(event) {
      const startX = event.clientX;
      const startY = event.clientY;
      const pw = this.$refs.moveDialog;
      const rectBox = pw.getBoundingClientRect();
      let moveX = 0;
      let moveY = 0;
      let flag = true;
      const moveEvent = (e) => {
        if (flag) {
          moveX = e.clientX - startX;
          moveY = e.clientY - startY;
          pw.style.left = rectBox.left + moveX + "px";
          pw.style.top = rectBox.top + moveY + "px";
          this.$nextTick(() => {
            // this.resizePlugin();
          });
        }
      };
      document.body.addEventListener("mousemove", moveEvent);
      const mouseUp = () => {
        flag = false;
        document.body.removeEventListener("mousemove", moveEvent);
        document.body.removeEventListener("mouseup", mouseUp);
      };
      document.body.addEventListener("mouseup", mouseUp);
    },
    // 关闭弹框
    handleClose() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.move-dialog {
  display: flex;
  flex-direction: column;
  position: fixed;
  font-size: 15px;
  user-select: none;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.6);
  box-shadow: 0 2px 10px 2px rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  left: 30%;
  top: 25%;
  padding: 0;
  z-index: 1001 !important;

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #2b5692;
    background-color: #eaf3fd;
    padding: 10px;
    cursor: move;
    border-radius: 5px;

    .close-btn {
      color: #909399;
      cursor: pointer;
    }
  }

  &-content {
    flex: 1;
    height: 0;
    overflow: auto;
  }
}
</style>
